export const openHouseRegistration = {
  meta: {
    title: "Inscription Journée Portes Ouvertes | Gándara International School",
    description: "Réservez votre place lors de notre prochaine journée portes ouvertes. Découvrez notre méthodologie Montessori, nos installations et notre équipe pédagogique.",
  },
  hero: {
    title: "Journée Portes Ouvertes",
    subtitle: "Venez découvrir notre école Montessori et inscrivez-vous à notre prochaine journée",
    // ── Changer cette date pour les prochaines journées ──
    date: "28 février 2026",
    badge: "Places limitées",
  },
  formTitle: "Réservez votre place",
  formSubtitle: "Remplissez vos coordonnées et nous confirmerons votre présence",
  highlights: {
    title: "Que découvrirez-vous ?",
    items: [
      "Notre méthodologie Montessori en action",
      "Les installations et espaces naturels",
      "L'équipe pédagogique et son approche",
      "Le modèle trilingue (espagnol, anglais, galicien)",
    ],
  },
};
